import { render } from "./MessageRender.vue?vue&type=template&id=658d94d2&scoped=true"
import script from "./MessageRender.vue?vue&type=script&lang=js"
export * from "./MessageRender.vue?vue&type=script&lang=js"

import "./MessageRender.vue?vue&type=style&index=0&id=658d94d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658d94d2"]])

export default __exports__